import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'clearContainer',
    `
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
	`
  ],
  [
    'clear',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		font-size: 14px;
		color: ${theme.color.text.B4};
		transition: color 0.3s ease;
		cursor: pointer;

		&:hover {
			color: ${theme.color.primary.default};
		}
	`
  ],
  [
    'clearIcon',
    `
		margin-left: 5px;
	`
  ]
]);
